import { AbstractControl, Validators } from '@angular/forms';
import { CallbackTranformsEnum } from '../../utils/reactive-forms/inputsTranforms';

export type ToolbarOptions = (string[] | Record<string, unknown>)[];

export const appDateFormat = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export enum CopyUbicationInput {
  IN_LABEL = 'in_label',
  IN_INPUT = 'in_input',
}

export enum TypeInput {
  INPUT = 'input',
  PERCENTAGE = 'percentage',
  NUMBER_PLUS_AND_LESS = 'number-plus-and-less',
  NUMBER_COMPACT = 'number-compact',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  MULTI_SELECT_ALL = 'multi-select-all',
  DATE = 'date',
  YEAR_PICKER = 'year_picker',
  DATE_CUSTOM = 'date_custom',
  UPLOAD = 'upload',
  UPLOAD_INDIVIDUAL_BTN = 'upload_individual_btn',
  UPLOAD_DRAG_AND_DROP = 'upload_drag_and_drop',
  UPLOAD_IMAGES = 'upload_images',
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  TOGGLE = 'toggle',
  CHECKBOX_INDIVIDUAL = 'checkbox_individual',
  AUTOCOMPLETE_SELECT = 'autocomplete_select',
  AUTOCOMPLETE_STRING = 'autocomplete_string',
  TEXT_AREA = 'text_area',
  COLOR = 'color',
  COPY = 'copy',
  TEXT_RICH = 'text_rich',
}

export interface IInputCustom {
  field: string; // campo, debe existir en el objeto a mapear
  label: string; // label a mostrar
  initialValue: any; // valor initial del cmapo
  typeInput: TypeInput; // tipo de input
  additionalProps: IInputCumstomAdditionals;
}

export interface IInputCumstomAdditionals {
  validators?: Validators[]; // validadores de ese campo
  validatorsAsync?: any[];
  msgError?: string; // mensaje de error si no cumple los validators
  messageErrors?: any; //objeto con los mensajes de error
  isDisable?: boolean; // deshabilitado
  showRequiredErrorWhenDisabled?: boolean;
  transform?: CallbackTranformsEnum; // para transformar el input Ex: a mayusculas
  placeholder?: string;
  isBoldLabel?: boolean;
  isHiddenLabel?: boolean;
  typeInput?: string;

  // para selects
  values?: any; // array de valores
  initialValues?: any; // array values initial
  keyForValueSelect?: string; // valor para emitir el option
  keyForDescSelect?: string; // valor para mostrar en el option
  emitUntilSelect?: boolean;

  //dependencias
  dependsOf?: string; // de que input depende
  showByDependency?: boolean; // se muestra solamente cuando el input padre lo seleccione

  optionalInput?: boolean; //label optional
  //file
  maxSizeFile?: number;
  showRefresh?: boolean;
  showPreview?: boolean;
  showDelete?: boolean;
  orientationImageResizen?: any;
  dataForSetUrlInImage?: any;
  systemImage?: string;

  //date
  showDateFormat?: boolean;
  pickerType?: 'both' | 'calendar' | 'timer';
  hour12Timer?: boolean;

  //text area
  rows?: number;
  cols?: number;

  minDate?: Date;
  maxDate?: Date;

  subLabel?: string; // sub label debajo del input

  //referencia de inputs
  ref?: string | number;

  //toggle labels\
  tgActive?: string;
  tgInactive?: string;

  canSelectOption?: boolean;

  //color picker
  customColors?: string[];
  showInstructions?: boolean;

  //icon copy ubication
  iconCopyUbication?: CopyUbicationInput;

  //multiselect optimized
  enableCheckAll?: boolean;
  showOnlyActive?: boolean;
  hiddenCheckMultiselect?: boolean;
  skipFirstClear?: boolean;

  // select disble options
  thereIsDisableOptions?: boolean;

  // should cleand autocomplete_select
  cleanAutocompleteByEmpty?: boolean;

  isLoading?: boolean;
  minValue?: number;
  maxValue?: number;
  labelAlignment?: 'center' | 'left' | 'right';

  textRichModules?: ToolbarOptions;
  textRichAllowImage?: boolean;
}

export interface IEmitedValue {
  ref?: string | number;
  field: string;
  control?: AbstractControl;
  value: any;
  typeInput?: TypeInput;
  typeValue?: string;
  auxControl?: AbstractControl;
  originalData?: any;
}

export interface IFormCustom<T = any> {
  valid: boolean;
  value: T;
}
